import React, { Component } from 'react'
import autoBind from 'react-autobind'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Container } from 'semantic-ui-react'

import Calendar from '../calendar'
import Navbar from '../navbar'
import Participants from '../participants'
import cookie from 'react-cookies'
import { send } from '../../helpers/requests'
import { setLanguage } from '../../helpers/languages'

class Dashboard extends Component {
    constructor (props) {
        super(props)
        autoBind(this)
        this.checkLanguage()
    }

    checkLanguage () {
        let lang = cookie.load('language') ? cookie.load('language') : 'en'
        setLanguage(lang)
        if (this.props.language !== lang) {
            // this.updateTherapist(lang)
        }
    }

    // Updates the therapist's language.
    updateTherapist (language, token) {
        // eslint-disable-next-line no-console
        console.log('Update therapist\'s language.')
        const profile = {
            language: language
        }
        send({
            method: 'PUT',
            tokens: this.props.userTokens,
            url: '/therapist',
            data: profile
        })
            .then((_response) => {
                // eslint-disable-next-line no-console
                console.log('Updated therapist\'s language.')
            })
            .catch((error) => {
                // Failed to fetch therapist.
                // eslint-disable-next-line no-console
                console.error('Failed to update therapist\'s language.', error)
            })
    }

    render () {
        return (
            <Container className='dashboard'>
                <Navbar/>
                <Container className='but-navbar'>
                    <Participants/>
                    <Calendar/>
                </Container>
            </Container>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        language: state.settings.language,
        userTokens: state.users.userTokens
    }
}

const mapDispatchToProps = (_dispatch) => {
    return {}
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Dashboard))



// WEBPACK FOOTER //
// ./src/components/dashboard/index.js